import { render } from "./ts-loader.vue?vue&type=template&id=455dbeeb&scoped=true"
import script from "./ts-loader.vue?vue&type=script&setup=true&lang=js"
export * from "./ts-loader.vue?vue&type=script&setup=true&lang=js"

import "./ts-loader.vue?vue&type=style&index=0&id=455dbeeb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455dbeeb"],['__file',"src/Global/components/ts-loader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "455dbeeb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('455dbeeb', __exports__)) {
    api.reload('455dbeeb', __exports__)
  }
  
  module.hot.accept("./ts-loader.vue?vue&type=template&id=455dbeeb&scoped=true", () => {
    api.rerender('455dbeeb', render)
  })

}


export default __exports__